import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { FaRegTimesCircle } from "react-icons/fa";
import { useGetState } from "../../context/useGetState";
import LoginAlternative from "./LoginAlternative";
import image from "../../assets/image.jpeg";
import splash from "../../assets/splash.jpg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { _register } from "./service" ;
import { ImArrowRight, ImBackward, ImForward, ImForward2 } from "react-icons/im";

function ForgotPassword({ next, prev, setPrevStep, ...props }) {
  const { dispatch } = useGetState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);

      const submit = async (values) => {
        setLoading(true);
        const payload = {
          username:values.username,
          email:values.email,
          password:values.password,
        };
        dispatch({ payload });
        // Save username to sessionStorage
        sessionStorage.setItem("username", values.username);
        sessionStorage.setItem("email", values.email);
        sessionStorage.setItem("password", values.password);
        await _register(payload, next, setLoading);
        sessionStorage.setItem("step_progress", true);
        setLoading(false);
      };

  const totalStep = sessionStorage.getItem("totalStep" || 0);
  const handleNext = () => {
    next(); // Call the prev function to go back to EmailScreen
  };

  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#000" },
  };

  const formikRef = useRef(null); // Create a ref for Formik

  useEffect(() => {
    // Retrieve values from sessionStorage
    const email_initialValue = sessionStorage.getItem("email") || "";
    const password_initialValue = sessionStorage.getItem("password") || "";
    const username_initialValue = sessionStorage.getItem("username") || "";

    // Set initial values using Formik ref
    if (formikRef.current) {
      formikRef.current.setFieldValue("email", email_initialValue);
      formikRef.current.setFieldValue("password", password_initialValue);
      formikRef.current.setFieldValue("username", username_initialValue);
    }
  }, []); // Empty dependency array
  

  return (
    <>
      <Center backgroundImage={splash} height="100vh">
        <Grid>
          <Box
            as="form"
            onSubmit={handleSubmit(submit)}
            my={"11"}
            backgroundColor={"#020B19"}
            h={"80vh"}
            w={"980px"}
            borderWidth={1}
            borderColor={"#66666680"}
            borderRadius={"24px"}
            boxShadow="lg"
          >
            <Stack direction={{ base: "column", md: "row" }}>
              <Flex
                p={"2%"}
                color={"white"}
                flex={1}
                align={"center"}
                justify={"center"}
              >
                <Stack spacing={4} w={"full"} maxW={"md"}>
                  <Box w={"268px"} h={"110px"}>
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                    />
                    <Heading
                      color={"#ffffff"}
                      paddingTop={1}
                      fontSize={"32px"}
                      fontWeight={500}
                      //fontSize={"2xl"}
                      letterSpacing={0}
                      lineHeight={"normal"}
                    >
                      Forgot Password?
                    </Heading>
                    <Flex>
                      <Text
                        fontWeight={400}
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        color={"white"}
                        fontSize={"16px"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                      >
                        Already have an account?{" "}
                      </Text>

                      <Text
                        color={"blue.500"}
                        fontWeight={400}
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        fontSize={"16px"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                        cursor="pointer"
                        onClick={() =>
                          dispatch({
                            signin: true,
                            forgotPassword: false,
                            resetPassword: false,
                          })
                        }
                      >
                        Sign in
                      </Text>
                    </Flex>
                  </Box>

                  <FormControl id="email">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"16px"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Email address
                    </FormLabel>
                    <Input
                      {...register("email", { required: true })}
                      //color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      w={"100%"}
                      type="email"
                    />
                    {errors.email && <span>This field is required</span>}
                  </FormControl>

                  <Stack spacing={6}>
                    <Button
                      borderRadius={24}
                      //marginLeft={220}
                      bg={"#0076FF"}
                      width={200}
                      type="submit"
                      height={50}
                      variant={"solid"}
                    >
                      {loading ? <Spinner /> : "continue"}
                    </Button>
                  </Stack>
                </Stack>
              </Flex>
              <Flex flex={1} align={"center"} justify={"center"}>
                <Image
                  alt={"Login Image"}
                  height={"403px"}
                  marginTop={20}
                  width={"311px"}
                  objectFit={"cover"}
                  src={logo}
                />
              </Flex>
            </Stack>
          </Box>
          <Flex mr={5} ml={5} justify={"space-between"}>
            <Box>
              <Select
                fontFamily={("Poppins-Regular", "Helvetica")}
                fontSize={".9em"}
                color={"white"}
                w="auto"
              >
                <option value="en"> English(Unites states)</option>
              </Select>
            </Box>
            <Box>
              <Flex mr={10} justify={"space-evenly"}>
                <Text
                  fontFamily={("Poppins-Regular", "Helvetica")}
                  fontSize={12}
                  color={"white"}
                >
                  Help
                </Text>
                <Text
                  fontFamily={("Poppins-Regular", "Helvetica")}
                  fontSize={12}
                  ml={"24px"}
                  color={"white"}
                >
                  Privacy
                </Text>
                <Text
                  fontFamily={("Poppins-Regular", "Helvetica")}
                  fontSize={12}
                  ml={"24px"}
                  color={"white"}
                >
                  Terms
                </Text>
              </Flex>
            </Box>
          </Flex>
        </Grid>
      </Center>
    </>
  );
}

export default ForgotPassword;
